// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jddF","controls":"styles_controls__2kUhr","charLimit":"styles_charLimit__2q0YM","input":"styles_input__1cIYK","send":"styles_send__1wdOR"};